import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import Icon from '../Icon'

import styles from './Chip.module.css'

export default function Chip({ icon, link, children, disabled }) {
  const Component = link ? Link : 'span'

  return (
    <span className={classNames(styles.wrapper, disabled && styles.disabled)}>
      <Component className={styles.chip} to={link}>
        <span>{children}</span>
        <span className={styles.icon}>
          {icon && <Icon icon={icon} color={disabled ? 'grey' : 'blue'} />}
        </span>
      </Component>
    </span>
  )
}
